module.exports = __webpack_public_path__ + "img/credit-card.f4d3fef5.svg";